import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import apiClient from '../services/apiClient.js';
import { setIsAutoScan } from '../redux/autoScanSlice.js';

export const useAutoScanSettings = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const isAutoScan = useSelector((state) => state.autoScan.isAutoScan);
  const [showUnauthorizedAlert, setShowUnauthorizedAlert] = useState(false);

  const getAccessToken = async () => getAccessTokenSilently({
    authorizationParams: {
      audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
    },
  });

  const loadAutoScanStatusAsync = async () => {
    if (!isAuthenticated) return;

    if (!user?.['/roles'] || user['/roles'].length === 0) {
      setShowUnauthorizedAlert(true);
      return;
    }

    const accessToken = await getAccessToken();
    const userRole = user['/roles'][0];
    const params = {
      serviceStationOwnerId: 'Shan',
      groupName: userRole,
    };
    const result = await apiClient.getAutoScansettingForServoAsync(params, accessToken);
    dispatch(setIsAutoScan(result.isAutoScanEnabled));
  };

  const updateAutoScanStatusAsync = async (newAutoScanStatus) => {
    if (!isAuthenticated || !user?.['/roles'] || user['/roles'].length === 0) return;

    const accessToken = await getAccessToken();
    const userRole = user['/roles'][0];
    const body = {
      isAutoScanEnabled: newAutoScanStatus,
      serviceStationOwnerId: 'Shan',
      groupName: userRole,
    };
    await apiClient.postAutoscanSettingForServo(body, accessToken);
    dispatch(setIsAutoScan(newAutoScanStatus));
  };

  useEffect(() => {
    loadAutoScanStatusAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return {
    isAutoScan,
    showUnauthorizedAlert,
    setShowUnauthorizedAlert,
    updateAutoScanStatusAsync,
  };
};

export default useAutoScanSettings;
